import { useEffect } from 'react';

// Lock the background without losing the user's position on mobile Safari.
let locks = 0;
let restorePage;
const lockPage = () => {
  if (locks++ === 0) {
    const { body } = document;
    const y = window.scrollY;
    const previous = {};
    ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach((key) => {
      previous[key] = body.style[key];
    });
    Object.assign(body.style, { position: 'fixed', top: `-${y}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
    restorePage = () => {
      Object.assign(body.style, previous);
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    };
  }
  return () => { if (--locks === 0) restorePage(); };
};

export default function useServiceDialog(ref, open, onClose) {
  useEffect(() => {
    if (!open || !ref.current) return undefined;
    const previousFocus = document.activeElement;
    const release = lockPage();
    const dialog = ref.current;
    dialog.focus({ preventScroll: true });
    const handleKey = (event) => {
      if (event.key === 'Escape') { event.preventDefault(); onClose(); }
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex="0"]')]
        .filter((el) => !el.disabled && el.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) {
        event.preventDefault(); first.focus();
      }
    };
    dialog.addEventListener('keydown', handleKey);
    return () => {
      dialog.removeEventListener('keydown', handleKey);
      release();
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, [open, ref, onClose]);
}
